import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import fundingBar from '../../assets/brand/prr-barra-financiamento.png';

export interface FundingBarProps {
  sx?: SxProps<Theme>;
}

/**
 * Mandatory PRR co-financing bar (Manual de Comunicação do PRR, sec. 2.2.1).
 * It is the official artwork, left unaltered, with the logos in the required order:
 * PRR, República Portuguesa, and the EU emblem with the NextGenerationEU funding statement.
 * The colour version is only legible on a white/light background, so the bar always has one.
 * Height is set and width is `auto` so the artwork is never distorted.
 */
export default function FundingBar({ sx }: FundingBarProps) {
  const { t } = useTranslation();
  return (
    <Box
      component="aside"
      aria-label={t('fundingBar.label')}
      sx={[
        {
          bgcolor: '#fff',
          borderTop: 1,
          borderColor: 'divider',
          py: 1.5,
          px: 2,
          // Keeps the logos clear of the fixed language switcher at the bottom left on narrow screens.
          pb: { xs: 9, sm: 1.5 },
          display: 'flex',
          justifyContent: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        component="img"
        src={fundingBar}
        alt={t('fundingBar.alt')}
        sx={{ height: { xs: 40, sm: 56 }, maxWidth: '100%', objectFit: 'contain', width: 'auto', display: 'block' }}
      />
    </Box>
  );
}
